import { FunctionComponent } from 'react';
import styles from '../TermsAndConditions.module.scss';

export type PADAgreementProps = {
  debitAuthority: string | undefined;
};

type FC = FunctionComponent<PADAgreementProps>;

const PADAgreement: FC = ({ debitAuthority = 'No PAD Agreement found' }: PADAgreementProps) => (
  <div className={styles.TermsConatinerWrapper}>
    <div className={styles.TermsConatiner}>
      <div dangerouslySetInnerHTML={{ __html: debitAuthority }} />
    </div>
  </div>
);

export default PADAgreement;
